module.exports = __webpack_public_path__ + "img/acurite-atlas.75358a7a.png";